import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: 'Strona główna', path: '/' },
  { label: 'Region', path: '/location' },
  { label: 'Sypialnie', path: '/bedrooms' },
  { label: 'Kalendarium', path: '/calendar' },
  { label: 'Dostępność', path: '/availability' },
  { label: 'Galeria', path: '/gallery' },
  { label: 'Kontakt', path: '/contact' },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const go = (path: string) => {
    navigate(path);
    setMenuOpen(false);
  };

  return (
    <>
      <nav className="nav">
        <div className="nav-inner">
          <div className="brand" onClick={() => go('/')}>
            <div className="brand-mark">W</div>
            <div className="brand-text">
              <div className="brand-title">Willa Toskania</div>
              <div className="brand-sub">Toskania · Włochy</div>
            </div>
          </div>

          <div className="nav-links">
            {navItems.map(item => (
              <a
                key={item.path}
                className={'nav-link ' + (location.pathname === item.path ? 'active' : '')}
                onClick={() => go(item.path)}
              >
                {item.label}
              </a>
            ))}
          </div>

          <button
            className="hamburger"
            onClick={() => setMenuOpen(x => !x)}
            aria-label="Menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <line x1="3" y1="7" x2="21" y2="7" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="17" x2="21" y2="17" />
            </svg>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="mobile-nav-overlay" onClick={() => setMenuOpen(false)} />
      )}

      <div className={'mobile-nav ' + (menuOpen ? 'open' : '')}>
        <button
          onClick={() => setMenuOpen(false)}
          style={{ position: 'absolute', top: 20, right: 20, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink)' }}
          aria-label="Zamknij menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        {navItems.map(item => (
          <a
            key={item.path}
            className={'mobile-nav-link ' + (location.pathname === item.path ? 'active' : '')}
            onClick={() => go(item.path)}
          >
            {item.label}
          </a>
        ))}
      </div>
    </>
  );
};

export default Header;
